module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', [_vm._v("Books by Stephanie Bond")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HARLEQUIN BLAZE")])])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("SHE DID A BAD, BAD THING")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("WATCH AND LEARN")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("IN A BIND")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("NO PEEKING!")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("SEDUCTION BY THE BOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("HER SEXY VALENTINE")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("ONCE UP ON A VALENTINE")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("“All Tangled Up”")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MIRA BOOKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BODY MOVERS")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BODY MOVERS: 2 BODIES FOR THE PRICE OF 1")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BODY MOVERS: 3 MEN AND A BODY")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BODY MOVERS: 4 BODIES AND A FUNERAL")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BODY MOVERS: 5 BODIES TO DIE FOR")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BODY MOVERS: 6 KILLER BODIES")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BABY, DRIVE SOUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BABY, COME HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_vm._v("BABY, DON'T GO")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427a1f99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5bodiestodiefor_adc01.vue
// module id = 63
// module chunks = 0